import { ChangeDetectorRef, Component, ComponentFactory, ComponentFactoryResolver, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AnimationHelper } from 'src/app/helpers/animation.helper';
import { AsyncHelper } from 'src/app/helpers/async.helper';
import { IWindowContentCreation } from 'src/app/interfaces/os/window-content-creation.interface';
import { IWindowContent } from 'src/app/interfaces/os/window-content.interface';
import { WindowsManagerService } from 'src/app/services/os/windows-manager.service';
import { ThemeService } from 'src/app/services/ux/theme.service';
import { DynamicComponentContainerDirective } from '../../directives/dynamic-component-container.directive';
import { ResizableDraggableComponent } from '../../ux/resizable-draggable/resizable-draggable.component';

@Component({
  selector: 'app-window',
  templateUrl: './window.component.html',
  styleUrls: ['./window.component.scss']
})
export class WindowComponent implements OnInit, OnDestroy {
  @ViewChild("resizableDraggable") resizableDraggable: ResizableDraggableComponent;
  @ViewChild(DynamicComponentContainerDirective, { static: false }) dynamicComponentContainer: DynamicComponentContainerDirective;

  @Input() id = -1;
  @Input() title = "";
  @Input() icon = null;
  @Input() isDialog = false;
  @Input() positionLocked = false;
  @Input() overflow = false;
  @Input() hasFocus = false;
  @Input() isMaximized = false;

  private lastX = 100;
  private lastY = 100;
  private lastWidth = 400;
  private lastHeight = 300;

  private isReady = false;

  private contentComponent: IWindowContentCreation;

  constructor(
    private ref: ChangeDetectorRef,
    private componentFactoryResolver: ComponentFactoryResolver,
    public theme: ThemeService,
    private windowSv: WindowsManagerService) {
  }

  ngOnInit() {
    this.windowSv.setToWindow(this.id, "component", this);

    //  TODO  -> Fix this
    setTimeout(() => {
      AnimationHelper.animate(this.card, this.windowSv.openAnimation);
      this.isReady = true;
      this.ref.detectChanges();
    }, 100);
  }

  ngOnDestroy() {
    this.windowSv.setToWindow(this.id, "component", null);
  }

  private get card() {
    return `#window-card-${this.id}`;
  }

  get initialized() {
    return this.id >= 0;
  }

  get content(): IWindowContentCreation {
    return this.contentComponent;
  }

  @Input()
  set content(v: IWindowContentCreation) {
    this.contentComponent = v;
    this.loadComponent();
  }

  minimize(): void {
    this.windowSv.minimizeWindow(this.id);
  }

  restore(): void {
    this.windowSv.restoreWindowStatus(this.id);
  }

  maximize(): void {
    // this.resizableDraggable.left = 0;
    // this.resizableDraggable.top = 0;
    this.windowSv.maximizeWindow(this.id);
  }

  private animateRestore() {
    // AnimationHelper.animate(this.card, this.windowSv.restoreFromMaximizedAnimation);
  }

  private animateMaximize() {
    // AnimationHelper.animate(this.card, this.windowSv.maximizeAnimation);
  }

  private animateMinimize() {
    // AnimationHelper.animate(this.card, this.windowSv.minimizeAnimation);
  }

  close(): void {
    AnimationHelper.animate(this.card, this.windowSv.closeAnimation).finally(() => {
      this.windowSv.disposeWindow(this.id);
    });
  }

  onMove(position: { x: number, y: number }) {
    this.lastX = position.x;
    this.lastY = position.y;
  }

  onResize(size: { width: number, height: number }) {
    this.lastWidth = size.width;
    this.lastHeight = size.height;
  }

  getPosition() {
    return { x: this.resizableDraggable.left, y: this.resizableDraggable.top };
  }

  setPosition(position: { x: number, y: number }): void {
    this.resizableDraggable.left = position.x;
    this.resizableDraggable.top = position.y;
  }

  getSize() {
    return { width: this.resizableDraggable.width, height: this.resizableDraggable.height };
  }

  resize(size: { width: number, height: number }) {
    this.resizableDraggable.setSize(size.width, size.height);
  }

  private async loadComponent() {
    await AsyncHelper.waitFor(() => !!this.dynamicComponentContainer);

    const componentOrFactory = this.contentComponent.component as any;

    const componentFactory: ComponentFactory<any> =
      (componentOrFactory.componentType) ?
        componentOrFactory :
        this.componentFactoryResolver.resolveComponentFactory(componentOrFactory);

    const viewContainerRef = this.dynamicComponentContainer.viewContainerRef;
    viewContainerRef.clear();

    const componentRef = viewContainerRef.createComponent<IWindowContent>(componentFactory);
    componentRef.instance.start(this.contentComponent.data, this.id);

    setTimeout(() => {
      this.adaptToAppSize();
    }, 750);
  }

  private adaptToAppSize(): void {
    const app = document.querySelector(`#window-card-${this.id} main-application > div`);

    if (app) {
      const sizes = app.getBoundingClientRect();

      if (sizes && sizes.width > 0 && sizes.height > 0) {
        this.resizableDraggable.width = sizes.width + 20;
        this.resizableDraggable.height = sizes.height + 40;
      }

      // console.log("App", app, sizes);
    }
  }
}
